import { Theme, makeStyles } from "@material-ui/core/styles";

export const COLORS = ["#3d898f", "#603e7d", "#4644a0", "#616c43"];

export const useStyles = makeStyles((theme: Theme) => ({
  loading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  titleContainer: {
    marginBottom: "10px",
  },
  title: {
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(22),
    fontWeight: 600,
  },
  image: {
    width: "100%",
    margin: "10px 0",
  },
  viewMoreBtn: {
    fontfamily: "Inter",
    alignSelf: "right",
    justifySelf: "right",
    fontWeight: 600,
    color: "#F15A28",
    border: "none",
    backgroundColor: "transparent",
    fontSize: theme.typography.pxToRem(14),
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  courseOuterContainer: {
    display: "flex",
    width: "100%",
    gap: "24px",
    flexWrap: "wrap",
  },
  courseContainer: {
    height: "350px",
    width: "350px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: "24px",
    cursor: "pointer",
    backgroundBlendMode: "multiply",
  },
  color0: {
    backgroundSize: "150px 250px",
    background: `
        radial-gradient(200px at 100% 0, #d3d3d319 6.25%, #78787819 6.3% 18.75%, #d3d3d319 18.8% 31.25%, #78787819 31.3% 43.75%, #d3d3d319 43.8% 56.25%, #78787819 56.3% 68.75%, #00000019 0),
        radial-gradient(200px at 0 0, #d3d3d319 6.25%, #78787819 6.3% 18.75%, #d3d3d319 18.8% 31.25%, #78787819 31.3% 43.75%, #d3d3d319 43.8% 56.25%, #78787819 56.3% 68.75%, #00000019 0),
        radial-gradient(200px at 0 100%, #d3d3d319 6.25%, #78787819 6.3% 18.75%, #d3d3d319 18.8% 31.25%, #78787819 31.3% 43.75%, #d3d3d319 43.8% 56.25%, #78787819 56.3% 68.75%, #00000019 0),
        radial-gradient(200px at 100% 100%, #d3d3d319 6.25%, #78787819 6.3% 18.75%, #d3d3d319 18.8% 31.25%, #78787819 31.3% 43.75%, #d3d3d319 43.8% 56.25%, #78787819 56.3% 68.75%, #00000019 0),
        ${COLORS[0]};
      `,
  },
  color1: {
    backgroundSize: "150px 250px",
    background: `
        radial-gradient(200px at 100% 0, #d3d3d319 6.25%, #78787819 6.3% 18.75%, #d3d3d319 18.8% 31.25%, #78787819 31.3% 43.75%, #d3d3d319 43.8% 56.25%, #78787819 56.3% 68.75%, #00000019 0),
        radial-gradient(200px at 0 0, #d3d3d319 6.25%, #78787819 6.3% 18.75%, #d3d3d319 18.8% 31.25%, #78787819 31.3% 43.75%, #d3d3d319 43.8% 56.25%, #78787819 56.3% 68.75%, #00000019 0),
        radial-gradient(200px at 0 100%, #d3d3d319 6.25%, #78787819 6.3% 18.75%, #d3d3d319 18.8% 31.25%, #78787819 31.3% 43.75%, #d3d3d319 43.8% 56.25%, #78787819 56.3% 68.75%, #00000019 0),
        radial-gradient(200px at 100% 100%, #d3d3d319 6.25%, #78787819 6.3% 18.75%, #d3d3d319 18.8% 31.25%, #78787819 31.3% 43.75%, #d3d3d319 43.8% 56.25%, #78787819 56.3% 68.75%, #00000019 0),
        ${COLORS[1]};
      `,
  },
  color2: {
    backgroundSize: "150px 250px",
    background: `
        radial-gradient(200px at 100% 0, #d3d3d319 6.25%, #78787819 6.3% 18.75%, #d3d3d319 18.8% 31.25%, #78787819 31.3% 43.75%, #d3d3d319 43.8% 56.25%, #78787819 56.3% 68.75%, #00000019 0),
        radial-gradient(200px at 0 0, #d3d3d319 6.25%, #78787819 6.3% 18.75%, #d3d3d319 18.8% 31.25%, #78787819 31.3% 43.75%, #d3d3d319 43.8% 56.25%, #78787819 56.3% 68.75%, #00000019 0),
        radial-gradient(200px at 0 100%, #d3d3d319 6.25%, #78787819 6.3% 18.75%, #d3d3d319 18.8% 31.25%, #78787819 31.3% 43.75%, #d3d3d319 43.8% 56.25%, #78787819 56.3% 68.75%, #00000019 0),
        radial-gradient(200px at 100% 100%, #d3d3d319 6.25%, #78787819 6.3% 18.75%, #d3d3d319 18.8% 31.25%, #78787819 31.3% 43.75%, #d3d3d319 43.8% 56.25%, #78787819 56.3% 68.75%, #00000019 0),
        ${COLORS[2]};
      `,
  },
  color3: {
    backgroundSize: "150px 250px",
    background: `
        radial-gradient(200px at 100% 0, #d3d3d319 6.25%, #78787819 6.3% 18.75%, #d3d3d319 18.8% 31.25%, #78787819 31.3% 43.75%, #d3d3d319 43.8% 56.25%, #78787819 56.3% 68.75%, #00000019 0),
        radial-gradient(200px at 0 0, #d3d3d319 6.25%, #78787819 6.3% 18.75%, #d3d3d319 18.8% 31.25%, #78787819 31.3% 43.75%, #d3d3d319 43.8% 56.25%, #78787819 56.3% 68.75%, #00000019 0),
        radial-gradient(200px at 0 100%, #d3d3d319 6.25%, #78787819 6.3% 18.75%, #d3d3d319 18.8% 31.25%, #78787819 31.3% 43.75%, #d3d3d319 43.8% 56.25%, #78787819 56.3% 68.75%, #00000019 0),
        radial-gradient(200px at 100% 100%, #d3d3d319 6.25%, #78787819 6.3% 18.75%, #d3d3d319 18.8% 31.25%, #78787819 31.3% 43.75%, #d3d3d319 43.8% 56.25%, #78787819 56.3% 68.75%, #00000019 0),
        ${COLORS[3]};
      `,
  },
  courseTitle: {
    fontFamily: "Lato",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(26),
    color: "#FFFFFF",
  },
  modulesOuterContainer: {
    display: "flex",
  },
}));
